import { render, staticRenderFns } from "./Promo2021.vue?vue&type=template&id=28f60f0c&scoped=true&"
import script from "./Promo2021.vue?vue&type=script&lang=js&"
export * from "./Promo2021.vue?vue&type=script&lang=js&"
import style0 from "./Promo2021.vue?vue&type=style&index=0&id=28f60f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f60f0c",
  null
  
)

export default component.exports